import { UIConfigStateModel } from '../model/ui-config.model';

export class LoadUIConfig {
	static readonly type = '[UIConfig] Load UI Config Model';
	constructor(public organizationID: string, public appName: string) {}
}

export class SetUIConfig {
	static readonly type = '[UIConfig] Set the UI Config Model';
	constructor(public uiConfigStateModel: UIConfigStateModel) {}
}
